import React from 'react'
import Text from './../../shared/components/LayoutComponents/Text'
import Swiper from '../../shared/components/FormComponents/SwiperComponent'
import TextImage from '../../shared/components/LayoutComponents/TextImage'
import MasonryComponent from '../../shared/components/FormComponents/MasonryComponent'
import FeedbackContent from '../Feedback/FeedbackContent'
import Masonry from "../../shared/components/FormComponents/MasonryComponent";

export interface Props {
  reloadFeedback: () => void
}

const Day: React.FC<Props> = (props) => {
  return (
    <>
      <>

        <Text
          columns={1}
          elements={
            [
              { headline1: 'Girls Day bei 3m5', content: '' },
            ]
          }
        />

        <Masonry
          itemData={
            [
              { img: './images/PXL_20250403_111332629.jpg', title: '3m5.' },
              { img: './images/PXL_20250403_092128828.jpg', title: '3m5.' },
              { img: './images/PXL_20250403_092107943.jpg', title: '3m5.' },
              { img: './images/IMG_8301.jpg', title: '3m5.' },
              { img: './images/IMG_8303.jpg', title: '3m5.' },
            ]
          }
        />


        <Text
          columns={3}
          elements={
            [
              { headline2: 'Unser Tag', content: '' }
            ]
          }
        />
        <Text
          columns={3}
          elements={
            [
              { headline3: 'Vormittag', content: 'Am Vormittag haben uns die Mitarbeiter hier erstmal ein bisschen die Firma Vorgestellt und wir haben auch eine kleine Vorstellungsrunde gemacht. Danach haben wir wichtige Sachen, die auf die Website kommen müssen gesammelt. Kurz darauf haben wir dann auch schon den Aufbau der Website gemacht. Dann wurden wir in Gruppen aufgeteilt und haben verschiedene Sachen an unserem Projekt bearbeitet.' },
              { headline3: 'Mittag', content: 'Zum Mittag haben wir Pizza gegessen ( Mit ganz verschiedenen Belägen z.B. Hotdogpizza). Zwischendurch gab es auch Snacks die man sich jeder Zeit nehmen konnte. In der Pause waren wir draußen und haben mit einem süßen Hund namens Felix gespielt. Das Gelände und der Ausblick über die Elbe und die Stadt Dresden macht eine schöne Atmosphäre.' },
              { headline3: 'Nachmittag', content: 'Nach dem Mittagessen haben wir angefangen richtig die Website zu Programmieren und zu gestalten. Und schließlich alles zusammen gefügt. Danach haben wir uns verabschiedet. ' },
            ]
          }
        />

        <TextImage
          headline2={'Unser Eindruck'}
          imagePath={'./images/IMG_8334.jpg'}
          content={'Wir fanden den Tag sehr interessant, weil wir selbst eine Website erstellen durften. Die Leute sind sehr nett und es gibt auch einen süßen Hund der herum spaziert und sich streicheln lässt.Unser gesammt eindruck war , dass es eindeutig besser ist als Schule, wir fanden außerdem auch cool das wir mehr Praktisch gearbeitet haben und nicht so viel Theorie machen mussten.' }
        />

      </>
    </>
  )
}
export default Day
